if (!customElements.get('automobrix-footer')) {
  customElements.define('automobrix-footer', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.();
      const mobile = window.matchMedia('(max-width: 767px)');
      const groups = [...this.querySelectorAll('.automobrix-garage-footer__group')];
      const updateGroups = () => {
        groups.forEach(group => {
          if (mobile.matches && group.contains(document.activeElement)) group.querySelector('summary').focus();
          group.open = !mobile.matches;
        });
      };
      const changeCountry = event => {
        if (event.target.matches('[data-footer-country]')) event.target.form.requestSubmit();
      };
      updateGroups();
      mobile.addEventListener('change', updateGroups);
      this.addEventListener('change', changeCountry);
      this.cleanup = () => {
        mobile.removeEventListener('change', updateGroups);
        this.removeEventListener('change', changeCountry);
      };
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
}
